/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import * as global from "../../js/global" ;
    import * as helper from "../../js/helper";
    import total_expense_component from "../components/total-expense-component.vue";
    import property_component_horizontal from "../components/property-component-horizontal.vue";
	import property_information_component from "../components/property-information-component.vue";
	import property_features_component from "../components/property-features-component.vue";
	import uploader_contact_info_widget from "../widgets/uploader-contact-info-widget.vue";
    const __vue_script__ ={
        components: {
            total_expense_component,
            property_component_horizontal,
            property_information_component,
            property_features_component,
            uploader_contact_info_widget,
        },
		name:'single_property_component',
        props: {
            property_json: {
                type: String,
            },
            property_features_json: {
                type: String,
            },
            property_data: {
                type: Object,
            },
            property_features_data: {
                type: Object,
            },
        },
		data() {
			return {
                global,
                helper,
                frappe,
                is_loading: false,
                property: null,
                property_features:null,
                creation_date: new Date(),
                section_features: global.property_constants.section_features,
                map: null,
                map_marker: null,
                mapsLayerGroup: null,
                marker_popup: null,
                qrcode:null,
			};
		},
        mounted(){
            if(this.property_json != undefined)
                this.property = JSON.parse(this.property_json);
            else
                this.property = this.property_data;
            if(this.property_features_json != undefined)
                this.property_features = JSON.parse(this.property_features_json);
            else
                this.property_features = this.property_features_data;
            this.is_loading = true;
            this.creation_date = new Date(this.property.creation);
            this.is_loading = false;
            setTimeout(async ()=>{
                await this.setup_things();
                var navText = [
                        "<i class='ri-arrow-left-line'></i>",
                        "<i class='ri-arrow-right-line'></i>",
                ];
                if(frappe.lang_dir == "rtl"){
                    navText = [
                        "<i class='ri-arrow-right-line'></i>",
                        "<i class='ri-arrow-left-line'></i>",
                    ];
                }
                $('#discover-slide').owlCarousel({
                    items: 3,
                    loop: false,
                    rtl: frappe.lang_dir == "rtl",
                    margin: 10,
                    nav: true,
                    dots: false,
                    autoplay: true,
                    smartSpeed: 1000,
                    autoplayHoverPause: true,
                    navText: navText,
                    responsive: {
                        0: {
                            items: 2,
                        },
                        576: {
                            items: 3,
                        },
                        768: {
                            items: 3,
                        },
                        992: {
                            items: 4,
                        },
                        1200: {
                            items: 4,
                        },
                    },
                });
                
                $('.gallery-popup').each(function() {
                    $(this).magnificPopup({
                        delegate: 'a', 
                        type: 'image',
                        gallery: {
                            enabled:true
                        }
                    });
                });
                $('.popup-youtube, .popup-vimeo').magnificPopup({
                    disableOn: 300,
                    type: 'iframe',
                    mainClass: 'mfp-fade',
                    removalDelay: 160,
                    preloader: false,
                    fixedContentPos: false,
                });
                if(this.property.rega_data.adLicenseUrl && this.property.rega_data.adLicenseUrl != ""){
                    this.qrcode = new QRCode("qrcode", {
                        text: this.property.rega_data.adLicenseUrl,
                        width: 128,
                        height: 128,
                        class: "inline-block",
                        colorDark : "#000000",
                        colorLight : "#ffffff",
                    });
                }
            }, 500);
        },
		methods: {
            setup_things: async function () {
                var initial_lat = this.property.lat; 
                var initial_lng = this.property.lng;
                let corner1 = L.latLng(31.896210012370656, 33.96066018865814);
                let corner2 = L.latLng(17.613607036429755, 55.8301100044458);
                var google_street_layer = L.tileLayer(
                    "https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
                    {
                        maxZoom: 18,
                        minZoom: 6,
                        subdomains: ["mt0", "mt1", "mt2", "mt3"],
                        attribution: '&copy; <a href="https://maalek.net">Maalek.Net</a>',
                    }
                );
                var google_satellite_layer = L.tileLayer(
                    "https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
                    {
                        maxZoom: 18,
                        minZoom: 6,
                        subdomains: ["mt0", "mt1", "mt2", "mt3"],
                        attribution: '&copy; <a href="https://maalek.net">Maalek.Net</a>',
                    }
                );
                var open_street = L.tileLayer(
                    "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
                    {
                        maxZoom: 18,
                        minZoom: 6,
                        attribution: '&copy; <a href="https://maalek.net">Maalek.Net</a>',
                    }
                );
                this.mapsLayerGroup = new L.LayerGroup();
                this.markerLayerGroup = new L.LayerGroup();
                this.map = L.map("map", {
                    center: [initial_lat, initial_lng],
                    zoom: 17,
                    maxZoom: 18,
                    minZoom: 12,
                    dragging: false,
                    maxBounds: L.latLngBounds(corner1, corner2),
                    layers: [
                        this.mapsLayerGroup,
                        this.markerLayerGroup,
                    ],
                }); //.setView([26.354351281510784, 43.95774780060444], 11);
                this.map.scrollWheelZoom.disable();
                this.mapsLayerGroup.addLayer(open_street);

                this.map_marker = L.marker([initial_lat, initial_lng]);
                this.marker_popup = L.popup();
                this.marker_popup.setContent("<a href='https://maps.google.com/?q="+initial_lat+","+initial_lng+"' target='_blank'><i class='fa-solid fa-map-location-dot m-1'></i> "+helper.t("Open in Google map")+"</a>");
                this.markerLayerGroup.addLayer(this.map_marker);
                this.map_marker.bindPopup(this.marker_popup);
                var baseLayers = frappe.lang_dir=='ltr'?{
                    "Map 1": open_street,
                    "Map 2": google_street_layer,
                    "Satellite": google_satellite_layer,
                }:{
                    "الخريطة 1": open_street,
                    "الخريطة 2": google_street_layer,
                    "القمر الصناعي": google_satellite_layer,
                };
                var layerControl = L.control.layers(baseLayers).addTo(this.map);
                latlng = L.latLng(initial_lat, initial_lng)
                // this.map_marker.setLatLng(latlng);
                // this.marker_popup.setLatLng(this.map_marker.getLatLng());
            },
			check_enabled: function(field){
				if (this.property.property_type=="")
					return false;
				return this.enabled_fields.includes(field);
			},
            check_section_enabled: function (array) {
                for (let i = 0; i < array.length; i++){
                    if(this.property[array[i]] == 1){
                        return true;
                    }
                }
                return false;
            },
            is_diagonal_view_sides(){
                diagonal_sides = ["NW","NE","SW","SE"]
                if(this.property.view_sides.some(value => diagonal_sides.includes(value))){
                    return true;
                }
                return false;
            },
            get_view_sides(){
                normal_sides = ["N","S","E","W"]
                diagonal_sides = ["NW","NE","SW","SE"]
                all_sides = normal_sides = ["N","S","E","W","NW","NE","SW","SE"]
                var sides = "";
                for (let i = 0; i < all_sides.length; i++){
                    if(this.property.view_sides.includes(all_sides[i])){
                        if(this.property.view_sides[0] == all_sides[i])
                            sides += all_sides[i].toLowerCase() + "m ";
                        else
                            sides += all_sides[i].toLowerCase() + " ";
                    }
                }
                if(this.is_diagonal_view_sides()){
                    sides += "rotate ";
                }
                return sides;
            },
            main_side_alignment(){
                // if (["N", "NE"].contains(viewSides.first))
                if (["N", "NE"].includes(this.property.view_sides[0]))
                    return "top-0 start-50";
                else if (["S", "SW"].includes(this.property.view_sides[0]))
                    return "top-100 start-50";
                else if (["W", "NW"].includes(this.property.view_sides[0]))
                    return frappe.lang_dir == "rtl"?"top-50 start-100":"top-50 start-0";
                else if (["E", "SE"].includes(this.property.view_sides[0]))
                    return frappe.lang_dir == "rtl"?"top-50 start-0":"top-50 start-100";
                return "top-50 start-50"
            }
		},
		computed:{
            enabled_fields(){
                var fields = global.property_constants.property_types[this.property.property_type];
                global.property_constants.remove_field[this.property.ad_type].forEach(field => {
                    const index = fields.indexOf(field);
                    if (index > -1) { // only splice array when item is found
                        fields.splice(index, 1); // 2nd parameter means remove one item only
                    }
                });
                global.property_constants.rega_features.forEach((field) => {
                    const index = fields.indexOf(field);
                    if (index > -1) {
                    fields.splice(index, 1);
                    }
                });
                return fields;
            }
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.property
    ? _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "section-card mt-4" },
            [
              _c("property_component_horizontal", {
                attrs: { property_data: _vm.property }
              }),
              _vm._v(" "),
              _c("property_information_component", {
                attrs: { property_data: _vm.property }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "add-listing col-lg-8" }, [
          _c("div", { staticClass: "properties-details-content" }, [
            _vm.property["description"]
              ? _c("div", { staticClass: "section-card mb-2 p-2" }, [
                  _c("h3", { staticClass: "mb-1" }, [
                    _vm._v(_vm._s(_vm.helper.t("Property Description")))
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.property["description"]) }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.property.rega_data.guaranteesAndTheirDuration &&
            _vm.property.rega_data.guaranteesAndTheirDuration != ""
              ? _c(
                  "div",
                  {
                    staticClass: "alert alert-secondary mb-2",
                    attrs: { role: "alert" }
                  },
                  [
                    _c("i", {
                      staticClass: "fa-solid fa-circle-info fa-lg mx-1"
                    }),
                    _vm._v(" "),
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.helper.t("guaranteesAndTheirDuration")) +
                          ": "
                      )
                    ]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.property.rega_data.guaranteesAndTheirDuration
                        ) +
                        "\n                "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.property.rega_data.obligationsOnTheProperty &&
            _vm.property.rega_data.obligationsOnTheProperty != ""
              ? _c(
                  "div",
                  {
                    staticClass: "alert alert-secondary mb-2",
                    attrs: { role: "alert" }
                  },
                  [
                    _c("i", {
                      staticClass: "fa-solid fa-triangle-exclamation fa-lg mx-1"
                    }),
                    _vm._v(" "),
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.helper.t("obligationsOnTheProperty")) + ": "
                      )
                    ]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.property.rega_data.obligationsOnTheProperty
                        ) +
                        "\n                "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.check_section_enabled(_vm.section_features)
              ? _c(
                  "div",
                  { staticClass: "section-card features-content p-2" },
                  [
                    _c("h3", { staticClass: "mb-2" }, [
                      _vm._v(_vm._s(_vm.helper.t("Features")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row" },
                      _vm._l(_vm.property_features, function(
                        feature,
                        feature_index
                      ) {
                        return _vm.property[feature] == 1
                          ? _c("div", { staticClass: "col-lg-3" }, [
                              _c("ul", [
                                _c("li", [
                                  _c("i", {
                                    staticClass: "ri-checkbox-circle-fill"
                                  }),
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.helper.t(feature)) +
                                      "\n                                "
                                  )
                                ])
                              ])
                            ])
                          : _vm._e()
                      }),
                      0
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "gap-mb-20" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "section-card p-2" },
              [
                _vm.property && _vm.property["video"]
                  ? _c("div", { staticClass: "video-img" }, [
                      _c("h3", [
                        _vm._v(_vm._s(_vm.helper.t("Property Video")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "video-wrap" }, [
                        _c("img", {
                          attrs: {
                            src:
                              "https://img.youtube.com/vi/" +
                              _vm.property["video_id"] +
                              "/maxresdefault.jpg",
                            alt: "Image"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "video-button" }, [
                          _c(
                            "a",
                            {
                              staticClass: "video-btn popup-youtube",
                              attrs: {
                                href:
                                  "https://www.youtube.com/watch?v=" +
                                  _vm.property["video_id"],
                                target: "_blank"
                              }
                            },
                            [_c("i", { staticClass: "ri-play-fill" })]
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.property["images"].length
                  ? [
                      _c("div", { staticClass: "gap-mb-20" }),
                      _vm._v(" "),
                      _c("h3", [
                        _vm._v(_vm._s(_vm.helper.t("Property Gallery")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "discover-area gallery-popup pv-3" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "owl-carousel owl-theme",
                              attrs: { id: "discover-slide" }
                            },
                            _vm._l(_vm.property["images"], function(image) {
                              return _c(
                                "div",
                                { staticClass: "single-discover" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "single-gallery background-image",
                                      staticStyle: { color: "RED" },
                                      style: {
                                        "background-image":
                                          "url(/" +
                                          encodeURIComponent(image.substr(1)) +
                                          ")"
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: image,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "ri-eye-line"
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      )
                    ]
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "section-card" }, [
              _c("div", { staticClass: "row map-location" }, [
                _c("div", { staticClass: "col" }, [
                  _c("h3", [_vm._v(_vm._s(_vm.helper.t("Location Map")))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "alert alert-info",
                      attrs: { role: "alert" }
                    },
                    [
                      _c("i", {
                        staticClass: "fa-solid fa-triangle-exclamation fa-xl"
                      }),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm.helper.t(
                              "Please match the location on the map with the location according to the deed"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _vm.property.rega_data.locationDescriptionOnMOJDeed &&
                      _vm.property.rega_data.locationDescriptionOnMOJDeed != ""
                        ? [
                            _vm._v(
                              ": " +
                                _vm._s(
                                  _vm.property.rega_data
                                    .locationDescriptionOnMOJDeed
                                )
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "position-relative" }, [
                    _c("div", { attrs: { id: "map" } }),
                    _vm._v(" "),
                    _c("div", { staticClass: "legend top-0 start-0" }, [
                      _c("h4", [
                        _vm._v(_vm._s(_vm.helper.t("Location Info.")))
                      ]),
                      _vm._v(" "),
                      _c("table", { staticClass: "table table-striped" }, [
                        _c("tbody", [
                          _c("tr", [
                            _c("td", [_vm._v(_vm._s(_vm.helper.t("Region")))]),
                            _c("td", { staticClass: "count" }, [
                              _vm._v(
                                _vm._s(_vm.property.rega_data.location.region)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v(_vm._s(_vm.helper.t("City")))]),
                            _c("td", { staticClass: "count" }, [
                              _vm._v(
                                _vm._s(_vm.property.rega_data.location.city)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [
                              _vm._v(_vm._s(_vm.helper.t("District")))
                            ]),
                            _c("td", { staticClass: "count" }, [
                              _vm._v(
                                _vm._s(_vm.property.rega_data.location.district)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v(_vm._s(_vm.helper.t("Street")))]),
                            _c("td", { staticClass: "count" }, [
                              _vm._v(
                                _vm._s(_vm.property.rega_data.location.street)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [
                              _vm._v(_vm._s(_vm.helper.t("Postal Code")))
                            ]),
                            _c("td", { staticClass: "count" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.property.rega_data.location.postalCode
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [
                              _vm._v(_vm._s(_vm.helper.t("Building Num")))
                            ]),
                            _c("td", { staticClass: "count" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.property.rega_data.location.buildingNumber
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [
                              _vm._v(_vm._s(_vm.helper.t("Additional Num")))
                            ]),
                            _c("td", { staticClass: "count" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.property.rega_data.location
                                    .additionalNumber
                                )
                              )
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-4" }, [
          _c("div", { staticClass: "widget-sidebar" }, [
            _c(
              "div",
              { staticClass: "sidebar-widget recent-post section-card mb-4" },
              [
                _c("h3", [_vm._v(_vm._s(_vm.helper.t("Advertisement Info.")))]),
                _vm._v(" "),
                _c("table", { staticClass: "table table-striped text-break" }, [
                  _c("tbody", [
                    _c("tr", [
                      _c("td", [_vm._v(_vm._s(_vm.helper.t("falLicense")))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.property.rega_data
                              .brokerageAndMarketingLicenseNumber
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _vm._v(_vm._s(_vm.helper.t("adLicenseNumber")))
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.property.ad_license_number))])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v(_vm._s(_vm.helper.t("creationDate")))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm.property.rega_data.creationDate))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tr",
                      { class: _vm.property["expired"] ? "table-danger" : "" },
                      [
                        _c("td", [_vm._v(_vm._s(_vm.helper.t("endDate")))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.property.rega_data.endDate))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.property.rega_data.planNumber &&
                    _vm.property.rega_data.planNumber != ""
                      ? _c("tr", [
                          _c("td", [
                            _vm._v(_vm._s(_vm.helper.t("planNumber")))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.property.rega_data.planNumber))
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.property.rega_data.landNumber &&
                    _vm.property.rega_data.landNumber != ""
                      ? _c("tr", [
                          _c("td", [
                            _vm._v(_vm._s(_vm.helper.t("landNumber")))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.property.rega_data.landNumber))
                          ])
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _vm._m(0)
              ]
            ),
            _vm._v(" "),
            !_vm.property["own"]
              ? _c(
                  "div",
                  { staticClass: "sidebar-widget recent-post section-card" },
                  [
                    _c("h3", [_vm._v(_vm._s(_vm.helper.t("Contact Info")))]),
                    _vm._v(" "),
                    _c("uploader_contact_info_widget", {
                      attrs: { property_data: _vm.property }
                    }),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/user-catalogue/" + _vm.property["uploader_id"],
                          target: "_blank"
                        }
                      },
                      [
                        _c("i", { staticClass: "ri-booklet-line" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.helper.t("See full catalogue")) +
                            "\n                    "
                        )
                      ]
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "sidebar-widget recent-post section-card" },
                  [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.helper.t("You manage this property")))
                    ]),
                    _vm._v(" "),
                    _vm.property["title"]
                      ? _c("h6", [
                          _vm._v(_vm._s(_vm.helper.t("Number / Title")))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.property["title"]
                      ? _c("p", [_vm._v(_vm._s(_vm.property["title"]))])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.property["ad_type"] == "Rent"
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: "#",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#expenseDetailsModal",
                              "data-bs-property-name": _vm.property["name"]
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.helper.t("Expense Summary")) +
                                "\n                        "
                            ),
                            _c("i", { staticClass: "fa-solid fa-chart-column" })
                          ]
                        )
                      : _vm._e(),
                    _c("br"),
                    _vm._v(" "),
                    _vm.property["ad_type"] == "Rent"
                      ? _c(
                          "a",
                          {
                            staticClass: "btn default-btn equalizer mt-2",
                            attrs: {
                              href: "#",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#addExpenseModal",
                              "data-bs-property-name": _vm.property["name"]
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.helper.t("Add Expense")) +
                                "\n                    "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.property["expired"] && !_vm.property["locked"]
                      ? _c(
                          "a",
                          {
                            staticClass: "btn default-btn equalizer mt-2",
                            attrs: {
                              href:
                                "/account/edit-property/" + _vm.property["name"]
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.helper.t("Edit Property")) +
                                " "
                            ),
                            _c("i", {
                              staticClass: "fa-solid fa-pen-to-square",
                              attrs: {
                                "data-bs-toggle": "tooltip",
                                "data-bs-placement": "top",
                                title: _vm.helper.t("Edit")
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.property["expired"]
                      ? _c("h6", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.helper.t("Ad Expired")))
                        ])
                      : _vm._e()
                  ]
                )
          ])
        ])
      ])
    : _vm._e()
}
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-flex text-center justify-content-center" },
      [_c("div", { attrs: { id: "qrcode" } })]
    )
  }
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-88dbc35a_0", { source: "\n.icon{\n    width:10%;\n}\n.properties-img .image-holder{\n    display: block;\n    padding-top: 100%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n}\n#discover-slide.owl-theme .owl-nav {\n    position: unset;\n    top: -92px;\n    right: -5px;\n    margin-top: 0;\n}\n.view-sides-preview .preview{\n    height: 135px;\n    width: 135px;\n    margin: auto;\n    border: SOLID 10px LIGHTGRAY;\n}\n.view-sides-preview .rotate{\n    transform: rotateY(0deg) rotate(45deg);\n}\n.view-sides-preview .n, .view-sides-preview .ne{\n    border-top-color: #014116;\n}\n.view-sides-preview .s,.view-sides-preview .sw{\n    border-bottom-color: #014116;\n}\n.view-sides-preview .e,.view-sides-preview .se{\n    border-right-color: #014116;\n}\n.view-sides-preview .w, .view-sides-preview .nw{\n    border-left-color: #014116;\n}\n.view-sides-preview .nm, .view-sides-preview .nem{\n    border-top-color: orange;\n}\n.view-sides-preview .sm,.view-sides-preview .swm{\n    border-bottom-color: orange;\n}\n.view-sides-preview .em,.view-sides-preview .sem{\n    border-right-color: orange;\n}\n.view-sides-preview .wm, .view-sides-preview .nwm{\n    border-left-color: orange;\n}\n#map {\n    height: 480px;\n}\n.leaflet-container{\n    font-family: \"changa\", 'Source Sans Pro', sans-serif !important;\n    font-size: small !important;\n}\n.legend {\n    margin: 100px 20px;\n    padding: 6px 4px;\n    font-size: 14px;\n    background: rgba(255, 255, 255, 0.8);\n    line-height: 24px;\n    color: #555;\n    z-index: 500;\n    position: absolute;\n}\n.legend tr {\n    cursor: pointer;\n}\n.legend:hover {\n    background: white;\n}\n.legend h4 {\n    text-align: center;\n    font-size: 16px;\n    margin: 2px 12px 8px;\n    color: #777;\n}\n.legend img {\n    width: 20px;\n    height: 24px;\n}\n.legend i {\n    width: 18px;\n    height: 18px;\n    float: left;\n    margin: 0 8px 0 0;\n    opacity: 0.7;\n}\n.legend i.icon {\n    background-size: 18px;\n    background-color: rgba(255, 255, 255, 1);\n}\n#qrcode canvas{\n    display: none;\n}\n#qrcode img{\n    border: SOLID 6px lightgrey;\n    padding: 5px;\n}\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/components/single-property-component.vue"],"names":[],"mappings":";AA8cA;IACA,SAAA;AACA;AACA;IACA,cAAA;IACA,iBAAA;IACA,4BAAA;IACA,sBAAA;IACA,2BAAA;AACA;AACA;IACA,eAAA;IACA,UAAA;IACA,WAAA;IACA,aAAA;AACA;AACA;IACA,aAAA;IACA,YAAA;IACA,YAAA;IACA,4BAAA;AACA;AAEA;IACA,sCAAA;AACA;AAEA;IACA,yBAAA;AACA;AAEA;IACA,4BAAA;AACA;AAEA;IACA,2BAAA;AACA;AAEA;IACA,0BAAA;AACA;AAEA;IACA,wBAAA;AACA;AAEA;IACA,2BAAA;AACA;AAEA;IACA,0BAAA;AACA;AAEA;IACA,yBAAA;AACA;AACA;IACA,aAAA;AACA;AAEA;IACA,+DAAA;IACA,2BAAA;AACA;AAEA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,oCAAA;IACA,iBAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;AACA;AACA;IACA,eAAA;AACA;AACA;IACA,iBAAA;AACA;AACA;IACA,kBAAA;IACA,eAAA;IACA,oBAAA;IACA,WAAA;AACA;AAEA;IACA,WAAA;IACA,YAAA;AACA;AAEA;IACA,WAAA;IACA,YAAA;IACA,WAAA;IACA,iBAAA;IACA,YAAA;AACA;AAEA;IACA,qBAAA;IACA,wCAAA;AACA;AAEA;IACA,aAAA;AACA;AAEA;IACA,2BAAA;IACA,YAAA;AACA","file":"single-property-component.vue","sourcesContent":["<template>\r\n\t<div v-if=\"property\" class=\"row\">\r\n        <div class=\"container\">\r\n            <div class=\"section-card mt-4\">\r\n                <property_component_horizontal\r\n                    :property_data='property'\r\n                ></property_component_horizontal>\r\n                <property_information_component\r\n                    :property_data='property'\r\n                ></property_information_component>\r\n            </div>\r\n        </div>\r\n        <div class=\"add-listing col-lg-8\">\r\n            <div class=\"properties-details-content\">\r\n                <div v-if=\"property['description']\" class=\"section-card mb-2 p-2\">\r\n                    <h3 class=\"mb-1\">{{ helper.t(\"Property Description\") }}</h3>\r\n                    <p v-html=\"property['description']\"></p>\r\n                </div>\r\n                <div v-if=\"property.rega_data.guaranteesAndTheirDuration && property.rega_data.guaranteesAndTheirDuration!= ''\" class=\"alert alert-secondary mb-2\" role=\"alert\">\r\n                    <i class=\"fa-solid fa-circle-info fa-lg mx-1\"></i> <b>{{ helper.t(\"guaranteesAndTheirDuration\") }}: </b>\r\n                    {{ property.rega_data.guaranteesAndTheirDuration }}\r\n                </div>\r\n                <div v-if=\"property.rega_data.obligationsOnTheProperty && property.rega_data.obligationsOnTheProperty!= ''\" class=\"alert alert-secondary mb-2\" role=\"alert\">\r\n                    <i class=\"fa-solid fa-triangle-exclamation fa-lg mx-1\"></i> <b>{{ helper.t(\"obligationsOnTheProperty\") }}: </b>\r\n                    {{ property.rega_data.obligationsOnTheProperty }}\r\n                </div>\r\n                <div v-if=\"check_section_enabled(section_features)\" class=\"section-card features-content p-2\">\r\n                    <h3 class=\"mb-2\">{{ helper.t(\"Features\")}}</h3>\r\n                    <div class=\"row\">\r\n                        <div v-for=\"(feature,feature_index) in property_features\"\r\n                            v-if=\"property[feature] == 1\"\r\n                            class=\"col-lg-3\">\r\n                            <ul>\r\n                                <li>\r\n                                    <i class=\"ri-checkbox-circle-fill\"></i>\r\n                                    {{ helper.t(feature) }}\r\n                                </li>\r\n                            </ul>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"gap-mb-20\"></div>\r\n                <div class=\"section-card p-2\">\r\n                    <div v-if=\"property && property['video']\" class=\"video-img\">\r\n                        <h3>{{ helper.t(\"Property Video\") }}</h3>\r\n                        <div class=\"video-wrap\">\r\n                            <img :src=\"'https://img.youtube.com/vi/'+property['video_id']+'/maxresdefault.jpg'\" alt=\"Image\">\r\n                            <div class=\"video-button\">\r\n                                <a :href=\"'https://www.youtube.com/watch?v='+property['video_id']\" target=\"_blank\" class=\"video-btn popup-youtube\">\r\n                                    <i class=\"ri-play-fill\"></i>\r\n                                </a>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <!-- Start Discover Area -->\r\n                    <template v-if=\"property['images'].length\">\r\n                        <div class=\"gap-mb-20\"></div>\r\n                        <h3>{{ helper.t(\"Property Gallery\") }}</h3>\r\n                        <div class=\"discover-area gallery-popup pv-3\">\r\n                            <div id=\"discover-slide\" class=\"owl-carousel owl-theme\">\r\n                                <div  v-for=\"image in property['images']\" class=\"single-discover\">\r\n                                    <div class=\"single-gallery background-image\" \r\n                                        :style=\"{ 'background-image': `url(/${encodeURIComponent(image.substr(1))})` }\"\r\n                                        style=\"color:RED;\">\r\n                                        <a\r\n                                            class=\"\"\r\n                                            :href=\"image\" target=\"_blank\">\r\n                                            <i class=\"ri-eye-line\"></i>\r\n                                        </a>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </template>\r\n                </div>\r\n                <div class=\"section-card\">\r\n                    <!-- End Discover Area -->\r\n                    <!-- Start Gallery Area -->\r\n                    <div class=\"row map-location\">\r\n                        <div class=\"col\">\r\n                            <h3>{{ helper.t(\"Location Map\") }}</h3>\r\n                            <div class=\"alert alert-info\" role=\"alert\"><i class=\"fa-solid fa-triangle-exclamation fa-xl\"></i> <b>{{ helper.t(\"Please match the location on the map with the location according to the deed\") }}</b>\r\n                            <template  v-if=\"property.rega_data.locationDescriptionOnMOJDeed && property.rega_data.locationDescriptionOnMOJDeed != ''\">: {{ property.rega_data.locationDescriptionOnMOJDeed }}</template>\r\n                            </div>\r\n                            <div class=\"position-relative\">\r\n                                <div id=\"map\"></div>\r\n                                <div class=\"legend top-0 start-0\">\r\n                                    <h4>{{ helper.t(\"Location Info.\") }}</h4>\r\n                                    <table class=\"table table-striped\">\r\n                                        <tbody>\r\n                                            <tr>\r\n                                                <td>{{ helper.t(\"Region\") }}</td><td class=\"count\">{{ property.rega_data.location.region }}</td>\r\n                                            </tr>\r\n                                            <tr>\r\n                                                <td>{{ helper.t(\"City\") }}</td><td class=\"count\">{{ property.rega_data.location.city }}</td>\r\n                                            </tr>\r\n                                            <tr>\r\n                                                <td>{{ helper.t(\"District\") }}</td><td class=\"count\">{{ property.rega_data.location.district }}</td>\r\n                                            </tr>\r\n                                            <tr>\r\n                                                <td>{{ helper.t(\"Street\") }}</td><td class=\"count\">{{ property.rega_data.location.street }}</td>\r\n                                            </tr>\r\n                                            <tr>\r\n                                                <td>{{ helper.t(\"Postal Code\") }}</td><td class=\"count\">{{ property.rega_data.location.postalCode }}</td>\r\n                                            </tr>\r\n                                            <tr>\r\n                                                <td>{{ helper.t(\"Building Num\") }}</td><td class=\"count\">{{ property.rega_data.location.buildingNumber }}</td>\r\n                                            </tr>\r\n                                            <tr>\r\n                                                <td>{{ helper.t(\"Additional Num\") }}</td><td class=\"count\">{{ property.rega_data.location.additionalNumber }}</td>\r\n                                            </tr>                  \r\n                                        </tbody>\r\n                                    </table>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        \r\n        <div class=\"col-lg-4\">\r\n            <div class=\"widget-sidebar\">\r\n                <div class=\"sidebar-widget recent-post section-card mb-4\">\r\n                    <h3>{{ helper.t(\"Advertisement Info.\") }}</h3>\r\n                    <table class=\"table table-striped text-break\">\r\n                        <tbody>\r\n                            <tr>\r\n                                <td>{{ helper.t(\"falLicense\") }}</td>\r\n                                <td>{{ property.rega_data.brokerageAndMarketingLicenseNumber }}</td>\r\n                            </tr>\r\n                            <tr>\r\n                                <td>{{ helper.t(\"adLicenseNumber\") }}</td>\r\n                                <td>{{ property.ad_license_number }}</td>\r\n                            </tr>\r\n                            <tr>\r\n                                <td>{{ helper.t(\"creationDate\") }}</td>\r\n                                <td>{{ property.rega_data.creationDate }}</td>\r\n                            </tr>\r\n                            <tr :class=\"property['expired'] ? 'table-danger' : ''\">\r\n                                <td>{{ helper.t(\"endDate\") }}</td>\r\n                                <td>{{ property.rega_data.endDate }}</td>\r\n                            </tr>\r\n                            <tr v-if=\"property.rega_data.planNumber && property.rega_data.planNumber != ''\">\r\n                                <td>{{ helper.t(\"planNumber\") }}</td>\r\n                                <td>{{ property.rega_data.planNumber }}</td>\r\n                            </tr>\r\n                            <tr v-if=\"property.rega_data.landNumber && property.rega_data.landNumber != ''\">\r\n                                <td>{{ helper.t(\"landNumber\") }}</td>\r\n                                <td>{{ property.rega_data.landNumber }}</td>\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                    <div class=\"d-flex text-center justify-content-center\">\r\n                        <div id=\"qrcode\" class=\"\"></div>\r\n                    </div>\r\n                </div>\r\n                <div v-if=\"!property['own']\" class=\"sidebar-widget recent-post section-card\">\r\n                    <h3>{{ helper.t(\"Contact Info\") }}</h3>\r\n                    <uploader_contact_info_widget\r\n                        :property_data='property'\r\n                    ></uploader_contact_info_widget>\r\n                    <br>\r\n                    <a :href=\"'/user-catalogue/'+property['uploader_id']\" target=\"_blank\">\r\n                        <i class=\"ri-booklet-line\"></i> {{ helper.t(\"See full catalogue\") }}\r\n                    </a>\r\n                </div>\r\n                <div v-else class=\"sidebar-widget recent-post section-card\">\r\n                    <h3>{{ helper.t(\"You manage this property\") }}</h3>\r\n                    <h6 v-if=\"property['title']\">{{ helper.t(\"Number / Title\") }}</h6>\r\n                    <p v-if=\"property['title']\">{{ property['title'] }}</p>\r\n                    <a v-if=\"property['ad_type'] == 'Rent'\"\r\n                    href=\"#\" data-bs-toggle=\"modal\" data-bs-target=\"#expenseDetailsModal\" :data-bs-property-name='property[\"name\"]'>\r\n                        {{ helper.t(\"Expense Summary\") }}\r\n                        <i class=\"fa-solid fa-chart-column\"></i>\r\n                    </a><br>\r\n                    <a v-if=\"property['ad_type'] == 'Rent'\" class=\"btn default-btn equalizer mt-2\" href=\"#\" data-bs-toggle=\"modal\" data-bs-target=\"#addExpenseModal\" :data-bs-property-name='property[\"name\"]'>\r\n                        {{ helper.t(\"Add Expense\") }}\r\n                    </a>\r\n                    <a  v-if=\"!property['expired'] && !property['locked']\" class=\"btn default-btn equalizer mt-2\"\r\n                        :href=\"'/account/edit-property/'+property['name']\">\r\n                        {{ helper.t(\"Edit Property\") }} <i class=\"fa-solid fa-pen-to-square\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Edit')\"></i>\r\n                    </a>\r\n                    <h6 v-if=\"property['expired']\" class=\"text-danger\">{{ helper.t(\"Ad Expired\") }}</h6>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</template>\r\n\r\n<script>\r\n    import * as global from \"../../js/global\" ;\r\n    import * as helper from \"../../js/helper\";\r\n    import total_expense_component from \"../components/total-expense-component.vue\";\r\n    import property_component_horizontal from \"../components/property-component-horizontal.vue\";\r\n\timport property_information_component from \"../components/property-information-component.vue\";\r\n\timport property_features_component from \"../components/property-features-component.vue\";\r\n\timport uploader_contact_info_widget from \"../widgets/uploader-contact-info-widget.vue\";\r\n    export default{\r\n        components: {\r\n            total_expense_component,\r\n            property_component_horizontal,\r\n            property_information_component,\r\n            property_features_component,\r\n            uploader_contact_info_widget,\r\n        },\r\n\t\tname:'single_property_component',\r\n        props: {\r\n            property_json: {\r\n                type: String,\r\n            },\r\n            property_features_json: {\r\n                type: String,\r\n            },\r\n            property_data: {\r\n                type: Object,\r\n            },\r\n            property_features_data: {\r\n                type: Object,\r\n            },\r\n        },\r\n\t\tdata() {\r\n\t\t\treturn {\r\n                global,\r\n                helper,\r\n                frappe,\r\n                is_loading: false,\r\n                property: null,\r\n                property_features:null,\r\n                creation_date: new Date(),\r\n                section_features: global.property_constants.section_features,\r\n                map: null,\r\n                map_marker: null,\r\n                mapsLayerGroup: null,\r\n                marker_popup: null,\r\n                qrcode:null,\r\n\t\t\t};\r\n\t\t},\r\n        mounted(){\r\n            if(this.property_json != undefined)\r\n                this.property = JSON.parse(this.property_json);\r\n            else\r\n                this.property = this.property_data;\r\n            if(this.property_features_json != undefined)\r\n                this.property_features = JSON.parse(this.property_features_json);\r\n            else\r\n                this.property_features = this.property_features_data;\r\n            this.is_loading = true;\r\n            this.creation_date = new Date(this.property.creation);\r\n            this.is_loading = false;\r\n            setTimeout(async ()=>{\r\n                await this.setup_things();\r\n                var navText = [\r\n                        \"<i class='ri-arrow-left-line'></i>\",\r\n                        \"<i class='ri-arrow-right-line'></i>\",\r\n                ];\r\n                if(frappe.lang_dir == \"rtl\"){\r\n                    navText = [\r\n                        \"<i class='ri-arrow-right-line'></i>\",\r\n                        \"<i class='ri-arrow-left-line'></i>\",\r\n                    ];\r\n                }\r\n                $('#discover-slide').owlCarousel({\r\n                    items: 3,\r\n                    loop: false,\r\n                    rtl: frappe.lang_dir == \"rtl\",\r\n                    margin: 10,\r\n                    nav: true,\r\n                    dots: false,\r\n                    autoplay: true,\r\n                    smartSpeed: 1000,\r\n                    autoplayHoverPause: true,\r\n                    navText: navText,\r\n                    responsive: {\r\n                        0: {\r\n                            items: 2,\r\n                        },\r\n                        576: {\r\n                            items: 3,\r\n                        },\r\n                        768: {\r\n                            items: 3,\r\n                        },\r\n                        992: {\r\n                            items: 4,\r\n                        },\r\n                        1200: {\r\n                            items: 4,\r\n                        },\r\n                    },\r\n                });\r\n                \r\n                $('.gallery-popup').each(function() {\r\n                    $(this).magnificPopup({\r\n                        delegate: 'a', \r\n                        type: 'image',\r\n                        gallery: {\r\n                            enabled:true\r\n                        }\r\n                    });\r\n                });\r\n                $('.popup-youtube, .popup-vimeo').magnificPopup({\r\n                    disableOn: 300,\r\n                    type: 'iframe',\r\n                    mainClass: 'mfp-fade',\r\n                    removalDelay: 160,\r\n                    preloader: false,\r\n                    fixedContentPos: false,\r\n                });\r\n                if(this.property.rega_data.adLicenseUrl && this.property.rega_data.adLicenseUrl != \"\"){\r\n                    this.qrcode = new QRCode(\"qrcode\", {\r\n                        text: this.property.rega_data.adLicenseUrl,\r\n                        width: 128,\r\n                        height: 128,\r\n                        class: \"inline-block\",\r\n                        colorDark : \"#000000\",\r\n                        colorLight : \"#ffffff\",\r\n                    });\r\n                }\r\n            }, 500);\r\n        },\r\n\t\tmethods: {\r\n            setup_things: async function () {\r\n                var initial_lat = this.property.lat; \r\n                var initial_lng = this.property.lng;\r\n                let corner1 = L.latLng(31.896210012370656, 33.96066018865814);\r\n                let corner2 = L.latLng(17.613607036429755, 55.8301100044458);\r\n                var google_street_layer = L.tileLayer(\r\n                    \"https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}\",\r\n                    {\r\n                        maxZoom: 18,\r\n                        minZoom: 6,\r\n                        subdomains: [\"mt0\", \"mt1\", \"mt2\", \"mt3\"],\r\n                        attribution: '&copy; <a href=\"https://maalek.net\">Maalek.Net</a>',\r\n                    }\r\n                );\r\n                var google_satellite_layer = L.tileLayer(\r\n                    \"https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}\",\r\n                    {\r\n                        maxZoom: 18,\r\n                        minZoom: 6,\r\n                        subdomains: [\"mt0\", \"mt1\", \"mt2\", \"mt3\"],\r\n                        attribution: '&copy; <a href=\"https://maalek.net\">Maalek.Net</a>',\r\n                    }\r\n                );\r\n                var open_street = L.tileLayer(\r\n                    \"https://tile.openstreetmap.org/{z}/{x}/{y}.png\",\r\n                    {\r\n                        maxZoom: 18,\r\n                        minZoom: 6,\r\n                        attribution: '&copy; <a href=\"https://maalek.net\">Maalek.Net</a>',\r\n                    }\r\n                );\r\n                this.mapsLayerGroup = new L.LayerGroup();\r\n                this.markerLayerGroup = new L.LayerGroup();\r\n                this.map = L.map(\"map\", {\r\n                    center: [initial_lat, initial_lng],\r\n                    zoom: 17,\r\n                    maxZoom: 18,\r\n                    minZoom: 12,\r\n                    dragging: false,\r\n                    maxBounds: L.latLngBounds(corner1, corner2),\r\n                    layers: [\r\n                        this.mapsLayerGroup,\r\n                        this.markerLayerGroup,\r\n                    ],\r\n                }); //.setView([26.354351281510784, 43.95774780060444], 11);\r\n                this.map.scrollWheelZoom.disable();\r\n                this.mapsLayerGroup.addLayer(open_street);\r\n\r\n                this.map_marker = L.marker([initial_lat, initial_lng]);\r\n                this.marker_popup = L.popup();\r\n                this.marker_popup.setContent(\"<a href='https://maps.google.com/?q=\"+initial_lat+\",\"+initial_lng+\"' target='_blank'><i class='fa-solid fa-map-location-dot m-1'></i> \"+helper.t(\"Open in Google map\")+\"</a>\");\r\n                this.markerLayerGroup.addLayer(this.map_marker);\r\n                this.map_marker.bindPopup(this.marker_popup);\r\n                var baseLayers = frappe.lang_dir=='ltr'?{\r\n                    \"Map 1\": open_street,\r\n                    \"Map 2\": google_street_layer,\r\n                    \"Satellite\": google_satellite_layer,\r\n                }:{\r\n                    \"الخريطة 1\": open_street,\r\n                    \"الخريطة 2\": google_street_layer,\r\n                    \"القمر الصناعي\": google_satellite_layer,\r\n                };\r\n                var layerControl = L.control.layers(baseLayers).addTo(this.map);\r\n                latlng = L.latLng(initial_lat, initial_lng)\r\n                // this.map_marker.setLatLng(latlng);\r\n                // this.marker_popup.setLatLng(this.map_marker.getLatLng());\r\n            },\r\n\t\t\tcheck_enabled: function(field){\r\n\t\t\t\tif (this.property.property_type==\"\")\r\n\t\t\t\t\treturn false;\r\n\t\t\t\treturn this.enabled_fields.includes(field);\r\n\t\t\t},\r\n            check_section_enabled: function (array) {\r\n                for (let i = 0; i < array.length; i++){\r\n                    if(this.property[array[i]] == 1){\r\n                        return true;\r\n                    }\r\n                }\r\n                return false;\r\n            },\r\n            is_diagonal_view_sides(){\r\n                diagonal_sides = [\"NW\",\"NE\",\"SW\",\"SE\"]\r\n                if(this.property.view_sides.some(value => diagonal_sides.includes(value))){\r\n                    return true;\r\n                }\r\n                return false;\r\n            },\r\n            get_view_sides(){\r\n                normal_sides = [\"N\",\"S\",\"E\",\"W\"]\r\n                diagonal_sides = [\"NW\",\"NE\",\"SW\",\"SE\"]\r\n                all_sides = normal_sides = [\"N\",\"S\",\"E\",\"W\",\"NW\",\"NE\",\"SW\",\"SE\"]\r\n                var sides = \"\";\r\n                for (let i = 0; i < all_sides.length; i++){\r\n                    if(this.property.view_sides.includes(all_sides[i])){\r\n                        if(this.property.view_sides[0] == all_sides[i])\r\n                            sides += all_sides[i].toLowerCase() + \"m \";\r\n                        else\r\n                            sides += all_sides[i].toLowerCase() + \" \";\r\n                    }\r\n                }\r\n                if(this.is_diagonal_view_sides()){\r\n                    sides += \"rotate \";\r\n                }\r\n                return sides;\r\n            },\r\n            main_side_alignment(){\r\n                // if ([\"N\", \"NE\"].contains(viewSides.first))\r\n                if ([\"N\", \"NE\"].includes(this.property.view_sides[0]))\r\n                    return \"top-0 start-50\";\r\n                else if ([\"S\", \"SW\"].includes(this.property.view_sides[0]))\r\n                    return \"top-100 start-50\";\r\n                else if ([\"W\", \"NW\"].includes(this.property.view_sides[0]))\r\n                    return frappe.lang_dir == \"rtl\"?\"top-50 start-100\":\"top-50 start-0\";\r\n                else if ([\"E\", \"SE\"].includes(this.property.view_sides[0]))\r\n                    return frappe.lang_dir == \"rtl\"?\"top-50 start-0\":\"top-50 start-100\";\r\n                return \"top-50 start-50\"\r\n            }\r\n\t\t},\r\n\t\tcomputed:{\r\n            enabled_fields(){\r\n                var fields = global.property_constants.property_types[this.property.property_type];\r\n                global.property_constants.remove_field[this.property.ad_type].forEach(field => {\r\n                    const index = fields.indexOf(field);\r\n                    if (index > -1) { // only splice array when item is found\r\n                        fields.splice(index, 1); // 2nd parameter means remove one item only\r\n                    }\r\n                });\r\n                global.property_constants.rega_features.forEach((field) => {\r\n                    const index = fields.indexOf(field);\r\n                    if (index > -1) {\r\n                    fields.splice(index, 1);\r\n                    }\r\n                });\r\n                return fields;\r\n            }\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style>\r\n    .icon{\r\n        width:10%;\r\n    }\r\n    .properties-img .image-holder{\r\n        display: block;\r\n        padding-top: 100%;\r\n        background-repeat: no-repeat;\r\n        background-size: cover;\r\n        background-position: center;\r\n    }\r\n    #discover-slide.owl-theme .owl-nav {\r\n        position: unset;\r\n        top: -92px;\r\n        right: -5px;\r\n        margin-top: 0;\r\n    }\r\n    .view-sides-preview .preview{\r\n        height: 135px;\r\n        width: 135px;\r\n        margin: auto;\r\n        border: SOLID 10px LIGHTGRAY;\r\n    }\r\n\r\n    .view-sides-preview .rotate{\r\n        transform: rotateY(0deg) rotate(45deg);\r\n    }\r\n\r\n    .view-sides-preview .n, .view-sides-preview .ne{\r\n        border-top-color: #014116;\r\n    }\r\n\r\n    .view-sides-preview .s,.view-sides-preview .sw{\r\n        border-bottom-color: #014116;\r\n    }\r\n\r\n    .view-sides-preview .e,.view-sides-preview .se{\r\n        border-right-color: #014116;\r\n    }\r\n\r\n    .view-sides-preview .w, .view-sides-preview .nw{\r\n        border-left-color: #014116;\r\n    }\r\n\r\n    .view-sides-preview .nm, .view-sides-preview .nem{\r\n        border-top-color: orange;\r\n    }\r\n    \r\n    .view-sides-preview .sm,.view-sides-preview .swm{\r\n        border-bottom-color: orange;\r\n    }\r\n    \r\n    .view-sides-preview .em,.view-sides-preview .sem{\r\n        border-right-color: orange;\r\n    }\r\n    \r\n    .view-sides-preview .wm, .view-sides-preview .nwm{\r\n        border-left-color: orange;\r\n    }\r\n    #map {\r\n        height: 480px;\r\n    }\r\n\r\n    .leaflet-container{\r\n        font-family: \"changa\", 'Source Sans Pro', sans-serif !important;\r\n        font-size: small !important;\r\n    }\r\n\r\n    .legend {\r\n        margin: 100px 20px;\r\n        padding: 6px 4px;\r\n        font-size: 14px;\r\n        background: rgba(255, 255, 255, 0.8);\r\n        line-height: 24px;\r\n        color: #555;\r\n        z-index: 500;\r\n        position: absolute;\r\n    }\r\n    .legend tr {\r\n        cursor: pointer;\r\n    }\r\n    .legend:hover {\r\n        background: white;\r\n    }\r\n    .legend h4 {\r\n        text-align: center;\r\n        font-size: 16px;\r\n        margin: 2px 12px 8px;\r\n        color: #777;\r\n    }\r\n\r\n    .legend img {\r\n        width: 20px;\r\n        height: 24px;\r\n    }\r\n\r\n    .legend i {\r\n        width: 18px;\r\n        height: 18px;\r\n        float: left;\r\n        margin: 0 8px 0 0;\r\n        opacity: 0.7;\r\n    }\r\n\r\n    .legend i.icon {\r\n        background-size: 18px;\r\n        background-color: rgba(255, 255, 255, 1);\r\n    }\r\n\r\n    #qrcode canvas{\r\n        display: none;\r\n    }\r\n\r\n    #qrcode img{\r\n        border: SOLID 6px lightgrey;\r\n        padding: 5px;\r\n    }\r\n</style>\r\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/components/single-property-component.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__